<template>
  <div id="app">
    <ApiErrorModal v-if="$store.state.isApiDown" />
  <div :class="{ 'swoosh-bg' : $route.name === 'search' || $route.name === 'details' }" >

  </div>
    <tbi-nav-bar></tbi-nav-bar>
    <div class="browser-upgrade-prompt" v-if="!browserSupport">
      Your browser is out-of-date, and may result in style and functionality
      issues, please consider updating to a modern alternative:
      <br />
      <a
        href="https://www.google.com/chrome/?brand=CHBD&gclid=Cj0KCQjwpPHoBRC3ARIsALfx-_LORIy1A83i_ZjeeZyqcTDeOQjrTpiFXldHwybG3DHshaKeRhKS6jgaAqLhEALw_wcB&gclsrc=aw.ds"
        >Google Chrome</a
      >
      <br />
      <a href="https://www.mozilla.org/en-US/firefox/new/">Mozilla Firefox</a>
    </div>
    <div class="default-route-wrapper" :class="{
      'route-wrapper': !$route.name === 'confirmation',
      'z-1': $route.name === 'search'
      }">
      <router-view />
    </div>
    <FooterDesktop class="footer-desktop" />
    <FooterMobile class="footer-mobile" />
  </div>
</template>

<script>
const { detect } = require("detect-browser");
const browser = detect();

import { mapState } from "vuex";
import FooterDesktop from '@/components/investec/FooterDesktop.vue';
import FooterMobile from '@/components/investec/FooterMobile.vue';
import TbiNavBar from '@/components/investec/Navigation/NavBar.vue';
import ApiErrorModal from "@/components/ApiErrorModal.vue";
import {
  fetchProductHealth,
  HEALTHY_POLL_INTERVAL_MS,
  UNHEALTHY_POLL_INTERVAL_MS,
} from "@/services/apiHealth.service.js";

export default {
  data() {
    return {
      browserSupport: true,
      isSmallDevice: 768,
      healthPollTimer: null,
    };
  },
  computed: {
    progress: function() {
      return this.$store.state.progress;
    },
    ...mapState(["invsyUser", "isIframe"]),
  },
  mounted() {
    this.checkApiHealth();
    switch (browser && browser.name) {
      case "ie":
        console.log("Internet Explorer Detected, consider upgrade");
        this.browserSupport = false;
        break;
      default:
        console.log(browser.name);
        console.log("browser supported");
    }
    if (window !== window.parent) {
      this.$store.dispatch("initializeInvsy");
    }
  },
  destroyed() {
    this.clearHealthPoll();
  },
  methods: {
    clearHealthPoll() {
      if (this.healthPollTimer) {
        clearInterval(this.healthPollTimer);
        this.healthPollTimer = null;
      }
    },
    scheduleHealthPoll(isUnhealthy) {
      this.clearHealthPoll();
      const interval = isUnhealthy
        ? UNHEALTHY_POLL_INTERVAL_MS
        : HEALTHY_POLL_INTERVAL_MS;
      this.healthPollTimer = setInterval(() => this.checkApiHealth(), interval);
    },
    async checkApiHealth() {
      const result = await fetchProductHealth("cars");

      if (result.healthy) {
        if (this.$store.state.isApiDown) {
          this.$store.commit("setApiHealthy");
        }
        this.scheduleHealthPoll(false);
        return;
      }

      this.$store.commit("setApiDown", result.errorCode);
      this.scheduleHealthPoll(true);
    },
  },
  components: {
    TbiNavBar,
    FooterDesktop,
    FooterMobile,
    ApiErrorModal,
  },
};
</script>

<style lang="scss">
@import "./assets/styles/settings.scss";

* {
  box-sizing: border-box;
}

html,
body {
  max-width: 100%;
  overflow-x: hidden;
  background: #fff;
  margin: 0;
}
</style>

<style lang="scss" scoped>
@import "./assets/styles/settings.scss";

// By default, show the mobile footer and hide the desktop footer
.footer-desktop {
  display: none;
}
.footer-mobile {
  display: block;
}

.default-route-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
}

.browser-upgrade-prompt {
  margin: 20px;
  padding: 20px;
  border: 2px solid black;
  border-radius: 8px;
  font-size: 20px;
  font-weight: bold;
  background: white;
}

.route-wrapper {
  margin-top: 10px;
  max-width: -webkit-fill-available;
}

#app {
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: left;
  background: #F6F6F4;
}

.z-1 {
  z-index: 1;
}

.swoosh-bg {
  background-image: url('assets/images/background-swoosh.svg') !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  width: 100% !important;
  position: absolute;
  height: 60%;
  z-index: 0;
}

nav {
  background: $primary-dark;
  padding: $standard-padding;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100vw;
  height: 80px;
  border-bottom: 4px solid $primary-color;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    font-size: 24px;
    font-weight: 200;
    color: $grey;
    b {
      color: $light;
      font-weight: 600;
    }
  }
}

.select select,
.textarea,
.input,
.taginput .taginput-container.is-focusable {
  border: 1px solid rgba(2, 33, 77, 0.3);
  box-sizing: border-box;
  border-radius: 2px;
}

.vc-w-full {
  border: 1px solid rgba(2, 33, 77, 0.3) !important;
  box-sizing: border-box !important;
  border-radius: 2px !important;
}

@media (min-width: 1295px) {
  .footer-desktop {
    display: block;
  }
  .footer-mobile {
    display: none;
  }
}
</style>
